module.exports = __webpack_public_path__ + "static/media/server_error_image.a5c4105d.svg";